import { render, staticRenderFns } from "./PrivacyDialog.vue?vue&type=template&id=1ab5fe81"
import script from "./PrivacyDialog.vue?vue&type=script&lang=js"
export * from "./PrivacyDialog.vue?vue&type=script&lang=js"
import style0 from "./PrivacyDialog.vue?vue&type=style&index=0&id=1ab5fe81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports